// extracted by mini-css-extract-plugin
module.exports = {"root":"EmailForm_root__lzUz5","description":"EmailForm_description__ai69z","input":"EmailForm_input__cwug4","footer":"EmailForm_footer__HOXi_"};